import ListView, { ListViewItem } from '@ingka/list-view';
import headsetSvg from '@ingka/ssr-icon/paths/headset';
import heartSvg from '@ingka/ssr-icon/paths/heart';
import pencilSvg from '@ingka/ssr-icon/paths/pencil';
import screwSvg from '@ingka/ssr-icon/paths/screw';
import appMetadata from '@mvecom/common/utils/appMetadata';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PREFIX } from '../Skapa/constants/constants';
import { useSparepartsUrl } from './useSparepartsUrl';

import styles from './Linkouts.module.scss';

type Linkout = {
  icon: Parameters<typeof ListViewItem>[0]['leadingIcon'];
  i18key: string;
  href: string;
};

const favourites: Linkout = {
  icon: heartSvg,
  i18key: 'menu.ciam.links.favourites.label',
  href: '/favourites/',
};

const planners: Linkout = {
  icon: pencilSvg,
  i18key: 'menu.ciam.links.planners.label',
  href: '/planners/',
};

const customerService: Linkout = {
  icon: headsetSvg,
  i18key: 'menu.ciam.links.customerService.label',
  href: '/customer-service/',
};

function ikeaPage(path: string) {
  if (path.startsWith('http')) {
    return path;
  }
  const base = document.location.origin;
  const ru = appMetadata.getRetailUnit();
  const lc = appMetadata.getLanguage();

  return `${base}/${ru}/${lc}${path}`;
}

function correctDomain(url: string) {
  if (document.location.host === 'www.ikea.com') {
    return url;
  }
  return url.replace('https://www.ikea.com', 'https://www.cte.ikeadt.com');
}

export function Linkouts() {
  const { t } = useTranslation('profile');
  const sparepartsLink = useSparepartsUrl();

  const linkouts = useMemo(() => {
    if (sparepartsLink.status === 'Loading') {
      return [];
    }
    if (sparepartsLink.sparepartsUrl) {
      return [
        favourites,
        planners,
        {
          icon: screwSvg,
          i18key: 'menu.ciam.links.spareParts.label',
          href: correctDomain(sparepartsLink.sparepartsUrl),
        },
        customerService,
      ];
    }
    return [favourites, planners, customerService];
  }, [sparepartsLink.status, sparepartsLink.sparepartsUrl]);

  return (
    <ListView prefix={PREFIX} id="benefitslist" size="small" showDivider={false} className={styles.list}>
      {linkouts.map((linkout) => (
        <ListViewItem
          prefix={PREFIX}
          key={linkout.i18key}
          control="link"
          title={t(linkout.i18key)}
          leadingIcon={linkout.icon}
          controlIcon={null}
          href={ikeaPage(linkout.href)}
        />
      ))}
    </ListView>
  );
}
